import styled from "@emotion/styled";

export const AppLoadingContainer = styled.div({
    width: '100vw',
    height: '100vh',
    display: 'grid',
    justifyContent: 'center',
    alignItems: 'center',
})